import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { services } from "./serviceData";
import "./ServiceDetail.css";

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = services.find((item) => item.slug === slug);

  const handleExploreAllServices = (event) => {
    event.preventDefault();
    navigate("/");

    setTimeout(() => {
      const servicesSection = document.getElementById("services");
      if (servicesSection) {
        servicesSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  if (!service) {
    return (
      <main className="service-detail-page empty-state">
        <div className="service-detail-container">
          <h1>Service not found</h1>
          <Link to="/services" className="service-back-link">
            Back to services
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="service-detail-page">
      <section className="service-detail-hero">
        <div className="service-detail-container hero-content-wrap">
          <div className="hero-copy">
            <p className="service-eyebrow">{service.eyebrow}</p>
            <h1>{service.name}</h1>
            <p className="hero-summary">{service.summary}</p>
            <div className="hero-actions">
              <Link
                to="/"
                className="service-primary-btn"
                onClick={handleExploreAllServices}
              >
                Explore all Services
              </Link>
              <a
                href="https://meetings-na2.hubspot.com/adwise-media?uuid=b5338f0a-6ee1-4e2b-88df-ab25699ff81c"
                target="_blank"
                rel="noreferrer"
                className="service-secondary-btn"
              >
                Book a free Consultation
              </a>
            </div>
          </div>

          <div className="hero-panel">
            <div className="panel-badge">Growth System</div>
            <h3>{service.title}</h3>
            <p>{service.intro}</p>
          </div>
        </div>
      </section>

      <section className="service-detail-body">
        <div className="service-detail-container detail-grid">
          <div className="detail-card">
            <span className="card-kicker">What we do</span>
            <ul>
              {service.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="detail-card accent-card">
            <span className="card-kicker">Why it works</span>
            <ul>
              {service.benefits.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="service-detail-bottom">
        <div className="service-detail-container bottom-wrap">
          <div className="bottom-copy">
            <span className="card-kicker">Best for</span>
            <p>{service.idealFor}</p>
          </div>
          <div className="bottom-cta">
            <Link to="/contact" className="service-primary-btn">
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ServiceDetail;
